import { ca } from '@cian/analytics';
import { TProduct } from '../../types/recommendation';

export const trackRecommendationItemClick = (modelVersion: string, products: TProduct[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_similar_offers',
    label: 'user-based',
    modelVersion,
    page: {
      pageType: 'ListingFavorites',
    },
    products,
  });
};

export const trackRecommendationsView = (modelVersion: string, products: TProduct[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_similar_offers',
    label: 'user-based',
    modelVersion,
    page: {
      pageType: 'ListingFavorites',
    },
    products,
  });
};
